var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        width: 1200,
        height: 300,
        scrollable: "",
        "class-name": "vertical-center-modal",
      },
      on: { "on-cancel": _vm.cancal },
      model: {
        value: _vm.modalVisible,
        callback: function ($$v) {
          _vm.modalVisible = $$v
        },
        expression: "modalVisible",
      },
    },
    [
      _c("p", { attrs: { slot: "header" }, slot: "header" }, [
        _c("span", [_vm._v("按模板新增产品")]),
      ]),
      _c(
        "Form",
        { ref: "productForm", attrs: { "label-width": 100 } },
        [
          _c(
            "Row",
            { attrs: { gutter: 8 } },
            [
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "选择产品名称" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { clearable: "", filterable: "" },
                          model: {
                            value: _vm.productSelectCode,
                            callback: function ($$v) {
                              _vm.productSelectCode = $$v
                            },
                            expression: "productSelectCode",
                          },
                        },
                        _vm._l(_vm.productList, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.productUuid,
                              attrs: { value: item.productCode },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(item.productName) +
                                  "\n\t\t\t\t\t\t\t\t"
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _vm.productSelectCode
                    ? _c(
                        "FormItem",
                        { attrs: { label: "产品编码" } },
                        [
                          _c("Input", {
                            attrs: {
                              value: _vm.productSelectCode,
                              readonly: "",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("Col", { attrs: { span: "0" } }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          this.$checkAccessArray(["B", "C"])
            ? _c(
                "Button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.insertTempSumbit },
                },
                [_vm._v("以此产品为模板新增产品")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }